import { render, staticRenderFns } from "./LeftNavbar.vue?vue&type=template&id=4cb46f27"
import script from "./LeftNavbar.vue?vue&type=script&lang=js"
export * from "./LeftNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports